<template lang="pug">
  .room.dehumidifier(v-loading="loadingData")
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" :class="warningFlag1")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" :class="warningFlag2")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" :class="warningFlag3")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts4" :series="SinglePieHistogramWrapData4" :class="warningFlag4")
    .divice-block-line
      .divice-block-line-item
        single-histogram.divice-block-multi-item(:opts="singleHisOpts5" :series="regenerationTemperature" :class="warningFlag5")
        single-histogram.divice-block-multi-item(:opts="singleHisOpts6" :series="dehumidifierPower" :class="warningFlag6")
      .divice-block-line-item.divice-block-line-item-col
        .divice-block-line-item-col-top
          .divice-block-line-item-col-top-in
            SwitchStatus.divice-block-thin(:title="singleHisOpts7" :series="SwitchStatusData1")
            SwitchStatus.divice-block-thin(:title="singleHisOpts8" :series="SwitchStatusData2")
            SwitchStatus.divice-block-thin(:title="singleHisOpts9" :series="SwitchStatusData3")
          .divice-block-line-item-col-top-in
            SwitchStatus.divice-block-thin(:title="singleHisOpts10" :series="SwitchStatusData4")
            SwitchStatus.divice-block-thin(:title="singleHisOpts11" :series="SwitchStatusData5")
            SwitchStatus.divice-block-thin(:title="singleHisOpts12" :series="SwitchStatusData6")
        RunningTimeBig.divice-block-time(:title="singleHisOpts13" :series="RunningTimeData")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/dehumidifier_data.json'

export default {
  name: 'dehumidifier',
  data() {
    return {
      timer: null,
      loadingData: true,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      warningFlag6: '',
      stationId: '',
      regenerationTemperature: {},
      dehumidifierPower: {},
      RunningTimeData: null,
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SwitchStatusData3: null,
      SwitchStatusData4: null,
      SwitchStatusData5: null,
      SwitchStatusData6: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapData3: null,
      SinglePieHistogramWrapData4: null,
      SinglePieHistogramWrapOpts1: {
        title: '除湿机1再生入口 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts2: {
        title: '除湿机1再生出口 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts3: {
        title: '除湿机1处理入口 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts4: {
        title: '除湿机1处理出口 温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      singleHisOpts5: {
        title: '除湿机1再生过滤压差',
        histogramName1: '',
        max: 200,
        sign: '°C'
      },
      singleHisOpts6: {
        title: '除湿机1处理过滤压差',
        histogramName1: 'P',
        max: 200,
        sign: 'W'
      },
      deviceList: [],
      singleHisOpts7: '',
      singleHisOpts8: '',
      singleHisOpts9: '',
      singleHisOpts10: '',
      singleHisOpts11: '',
      singleHisOpts12: '',
      singleHisOpts13: '',
    }
  },
  created() {
    this.setTitles()
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  mounted() {
    // this.getInfo()
    this.getDatas()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
      this.warningFlag5 = ''
      this.warningFlag6 = ''
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceName
      this.$set(this.SinglePieHistogramWrapOpts1, 'title', deviceName[0])
      this.$set(this.SinglePieHistogramWrapOpts2, 'title', deviceName[1])
      this.$set(this.SinglePieHistogramWrapOpts3, 'title', deviceName[2])
      this.$set(this.SinglePieHistogramWrapOpts4, 'title', deviceName[3])
      this.$set(this.singleHisOpts5, 'title', deviceName[4])
      this.$set(this.singleHisOpts6, 'title', deviceName[5])
      this.singleHisOpts7 = deviceName[6]
      this.singleHisOpts8 = deviceName[7]
      this.singleHisOpts9 = deviceName[8]
      this.singleHisOpts10 = deviceName[9]
      this.singleHisOpts11 = deviceName[10]
      this.singleHisOpts12 = deviceName[11]
      this.singleHisOpts13 = deviceName[12]
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    getInfo() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/bridge/StationInfo?stationId=${stationId}`).then(res => {
        const __data = res.data.deviceList
        const list = __data.map(el => {
          return {
            deviceId: el.deviceId,
            deviceName: el.deviceName
          }
        })
        console.log('list', JSON.stringify(list))
      })
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDatas() {
      console.log('getDatas')
      const routerPath = this.$route.name.split('_')
      const deviceDataName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http
        .get(`/deviceData/Station?stationId=${stationId}`)
        .then(res => {
          this.loadingData = false
          this.$store.commit('setLastRefreshTime')
          const __data = res.data
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData1',
            this.findDeviceId(deviceDataName[0]),
            this.findDeviceId(deviceDataName[1]),
            'warningFlag1'
          )
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData2',
            this.findDeviceId(deviceDataName[2]),
            this.findDeviceId(deviceDataName[3]),
            'warningFlag2'
          )
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData3',
            this.findDeviceId(deviceDataName[4]),
            this.findDeviceId(deviceDataName[5]),
            'warningFlag3'
          )
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData4',
            this.findDeviceId(deviceDataName[6]),
            this.findDeviceId(deviceDataName[7]),
            'warningFlag4'
          )
          this.dehumidifierPower = {
            data: this.findDeviceData(__data, deviceDataName[8]).value
          }
          this.warningFlag6 = this.findDeviceData(__data, deviceDataName[8]).errorLevel
          this.regenerationTemperature = {
            data: this.findDeviceData(__data, deviceDataName[9]).value
          }
          this.warningFlag5 = this.findDeviceData(__data, deviceDataName[9]).errorLevel
          this.SwitchStatusData1 = {
            data: __data[this.findDeviceId(deviceDataName[10])].value,
            isError: __data[this.findDeviceId(deviceDataName[11])].errorLevel
          }
          this.SwitchStatusData2 = {
            data: __data[this.findDeviceId(deviceDataName[12])].value,
            isError: __data[this.findDeviceId(deviceDataName[13])].errorLevel
          }
          this.SwitchStatusData3 = {
            data: __data[this.findDeviceId(deviceDataName[14])].value,
            isError: __data[this.findDeviceId(deviceDataName[15])].errorLevel
          }
          this.SwitchStatusData4 = {
            data: __data[this.findDeviceId(deviceDataName[16])].value,
            isError: __data[this.findDeviceId(deviceDataName[17])].errorLevel,
            isZh: true
          }
          this.SwitchStatusData5 = {
            data: __data[this.findDeviceId(deviceDataName[18])].value,
            isError: __data[this.findDeviceId(deviceDataName[19])].errorLevel,
            isZh: true
          }
          this.SwitchStatusData6 = {
            data: __data[this.findDeviceId(deviceDataName[20])].value,
            isError: __data[this.findDeviceId(deviceDataName[21])].errorLevel,
            isZh: true
          }
          this.RunningTimeData =
            __data[this.findDeviceId(deviceDataName[22])].value
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dehumidifier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  ::v-deep .el-loading-mask{
    background-color: rgba(255, 255, 255, 0.6);
  }
  .divice-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      width: calc(100% / 2 - 8px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      .divice-block-multi-item {
        width: calc(50% - 7px);
      }
    }
    .divice-block-line-item-col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-top {
        display: flex;
        justify-content: space-between;
        height: 140px;
        &-in {
          display: flex;
          height: 100%;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
  .divice-block-thin {
    height: 38px;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .divice-block-time {
    height: calc(100% - 153px);
    width: 100%;
    box-sizing: border-box;
  }
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
}
</style>
